/**
 * @file This file contains theme color information and a hook to use the theme color.
 */
const theme = {
  COLOR_PRIMARY: '#ED1C24',
  COLOR_SECONDARY: '#000000',
  COLOR_WHITE: '#ffffff',
  COLOR_BLACK: '#000000',
  COLOR_BLUE: '#0068FF',
  COLOR_LIGHT_BLUE: '#E3E7FA',
  COLOR_BG_LIGHT: '#F9F9F9',
  COLOR_BG_DARK: '#F5F6FA',
  COLOR_GREY: '#F0F0F0',
  COLOR_GREY2: '#DFDFDF',
  COLOR_GREY3: '#B8B8B8',
  COLOR_GREY4: '#CCD0E3',
  COLOR_GREY5: '#EAEDF3',
  COLOR_TEXT: '#58595B',
  COLOR_GREY_TEXT: '#777777',
  COLOR_GREY_TEXT2: '#B8B8B8',
  COLOR_ERROR_TEXT: '#FF5353',
  COLOR_ORANGE: '#FFA500',
  COLOR_LINK: '#000000',
  COLOR_BOX_SHADOW: '#00000066',

  // disabled button
  COLOR_DISABLED_BUTTON: '#F0F0F0',
  COLOR_DISABLED_BUTTON_TEXT: '#B8B8B8',

  // primary button
  COLOR_PRIMARY_BUTTON: '#ED1C24',
  COLOR_PRIMARY_BUTTON_TEXT: '#FFFFFF',
  COLOR_PRIMARY_BUTTON_HOVER: '#C9171E',

  // primary outline button
  COLOR_PRIMARY_OUTLINE_BUTTON: '#FFFFFF',
  COLOR_PRIMARY_OUTLINE_BUTTON_TEXT: '#000000',
  COLOR_PRIMARY_OUTLINE_BUTTON_HOVER: 'rgba(0, 0, 0, 0.1)',

  // secondary button
  COLOR_SECONDARY_BUTTON: '#000000',
  COLOR_SECONDARY_BUTTON_TEXT: '#FFFFFF',
  COLOR_SECONDARY_BUTTON_HOVER: '#000000',

  // status
  COLOR_STATUS_GREEN: '#037B49',
  COLOR_STATUS_GREEN_TEXT: '#037B49',
  COLOR_STATUS_GREEN_BG: '#ECFDF3',
  COLOR_STATUS_ORANGE: '#FFA413',
  COLOR_STATUS_ORANGE_TEXT: '#FFA413',
  COLOR_STATUS_ORANGE_BG: '#FFF6E5',
  COLOR_STATUS_RED: '#FF5353',
  COLOR_STATUS_RED_TEXT: '#FF5353',
  COLOR_STATUS_RED_BG: '#FFEEEE',
  COLOR_STATUS_BLUE: '#0068FF',
  COLOR_STATUS_BLUE_TEXT: '#0068FF',
  COLOR_STATUS_BLUE_BG: '#E5F0FF',
  COLOR_STATUS_DEFAULT: '#F3F4F8',
  COLOR_STATUS_DEFAULT_TEXT: '#58595B',
  COLOR_STATUS_DEFAULT_BG: '#F3F4F8',
  COLOR_STATUS_PURPLE_TEXT: '#8100AC',
  COLOR_STATUS_PURPLE_BG: '#FAEBFF',

  // status tags
  COLOR_STATUS_TAG_PURPLE_TEXT: '#8076A7',
  COLOR_STATUS_TAG_PURPLE_BG: '#EAE5F2',
  COLOR_STATUS_TAG_BLUE_TEXT: '#5E6C89',
  COLOR_STATUS_TAG_BLUE_BG: '#E3E7FA',
  COLOR_STATUS_TAG_GREEN_TEXT: '#51708D',
  COLOR_STATUS_TAG_GREEN_BG: '#E1F3F7',
};

export default theme;
